exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-nav{width:342px;height:54px;margin:0 auto;overflow:auto;-webkit-box-shadow:inset 0px -1px 0 0px #ddd;box-shadow:inset 0px -1px 0 0px #ddd;white-space:nowrap}@media(min-width: 1160px){.user-nav{width:auto;height:68px;overflow:visible;margin:0;border-bottom:none;-webkit-box-shadow:none;box-shadow:none}}.user-nav a{position:relative;display:inline-block;vertical-align:bottom;padding:20px 0 13px;margin-right:16px;color:#909090;font-family:NeueHaasUnicaW1G;font-size:15px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:20px;cursor:pointer}.user-nav a:last-child{margin-right:0}@media(min-width: 1160px){.user-nav a{padding-bottom:24px;margin-right:40px;font-size:15px;line-height:24px}}.user-nav a.active{color:#333}.user-nav a.active::after{position:absolute;left:0;right:0;bottom:-1px;content:\"\";height:2px;background-color:#37b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/navigation/style.scss
// module id = 1509
// module chunks = 57